import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { FooterComponent } from '../../components/footer-main/footer-main';
import { FooterDesktopComponent } from '../../components/footer-desktop/footer-desktop';
import { HeaderComponent } from '../../components/header-main/header-main';
import { HeaderDesktopComponent } from '../../components/header-desktop/header-desktop';
import { AuthService } from '../../core/auth.service';

@Component({
    imports: [CommonModule, FooterComponent, FooterDesktopComponent, HeaderComponent, HeaderDesktopComponent, ReactiveFormsModule],
    selector: 'app-recover',
    styleUrls: ['./recover.page.scss'],
    templateUrl: './recover.page.html'
})
export class RecoverPage implements OnInit {
  public resetPasswordForm: any;

  constructor(
    private auth: AuthService, 
    private fb: FormBuilder, 
    private router: Router
  ) {

    let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
    this.resetPasswordForm = this.fb.group({
      email: ['', Validators.compose([Validators.required, Validators.pattern(EMAIL_REGEXP)])],
    });
  }

  async resetPassword(){
    await this.auth.resetPassword(this.resetPasswordForm.value.email);
    return this.router.navigate(['/login']);
  }

  ngOnInit() {
  }

}
